import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=2c94428e&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c94428e')) {
      api.createRecord('2c94428e', component.options)
    } else {
      api.reload('2c94428e', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=2c94428e&", function () {
      api.rerender('2c94428e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TmjCJ8aAlx5B/JS/offershelp.vue"
export default component.exports